import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PharmaInformation from '../../components/EnrollForm/PharmaInformation';
import BreadCrumbs from '../../components/Breadcrumbs';
import { withRouter } from 'react-router-dom';

const SignUp = (props) => {
  // let treatment = '';
  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      // treatment = <span>ALUNBRIG&reg; (brigatinib)</span>;
      gtmTrackId = 'track-203 gtm-track-65';
      break;
    case 'fruzaqla':
      // treatment = <span>FRUZAQLA<sup>&trade;</sup> (fruquintinib)</span>;
      gtmTrackId = 'track-203 gtm-track-65';
      break;
    case 'iclusig':
      // treatment = <span>ICLUSIG&reg; (ponatinib)</span>;
      gtmTrackId = 'track-203 gtm-track-66';
      break;
    case 'ninlaro':
      // treatment = <span>NINLARO&reg; (ixazomib)</span>;
      gtmTrackId = 'track-203 gtm-track-67';
      break;
    case 'mimrylo':
      // treatment = <span>NINLARO&reg; (ixazomib)</span>;
      gtmTrackId = 'track-203 gtm-track-68';
      break;
    default:
      // treatment = '';
      gtmTrackId = '';
  }
  return (
    <div className="sign-up full-width">
      <BreadCrumbs activeIndex={ 1 }/>
      <div className="wrapper">
        <Header as="h1">Now take a moment to fill out your patient’s personal information</Header>

        <PharmaInformation
          onSubmit={ props.onSubmit }
          environment={ props.environment }
          formType={ props.formType }
          submitTrackId= { gtmTrackId }
        />
      </div>
    </div>
  );
};

SignUp.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
};

export default withRouter(SignUp);
